import { PassouFalhouEnum } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { calculateResultadoPergunta16 } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-16/utils-consultaSeguimentoPergunta16'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'

import { HistoricoMchatExemplosPassouFalhouTableItem } from '../components/HistoricoMchatExemplosPassouFalhouTableItem'
import { HistoricoMChatHeaderTableItem } from '../components/HistoricoMchatHeaderTableItem'
import { HistoricoMChatPerguntaSection } from '../components/HistoricoMchatPerguntaSection'
import { HistoricoMChatResultadoParcialTableItem } from '../components/HistoricoMChatResultadoParcialTableItem'
import { HistoricoMChatSimpleHorizontalTableItem } from '../components/HistoricoMChatSimpleHorizontalTableItem'
import { convertAplicacaoPergunta16, formatPergunta16Frequencia } from './converter-HistoricoMchatPergunta16'

interface HistoricoMChatRfPergunta16Props {
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
}

export const HistoricoMChatRfPergunta16 = (props: Readonly<HistoricoMChatRfPergunta16Props>) => {
  const { aplicacoes } = props

  const converted = convertAplicacaoPergunta16(aplicacoes)
  if (converted == null) return null

  const { header, exemplosPassou, exemplosFalhou, frequencia, model } = converted
  if (header === null) return null

  const resultado = calculateResultadoPergunta16(model)
  const hasExemplos = exemplosPassou.isNotEmpty() || exemplosFalhou.isNotEmpty()

  return (
    <HistoricoMChatPerguntaSection>
      <HistoricoMChatHeaderTableItem
        numeroPergunta='16'
        title={header.textoPergunta}
        value={header.stPassou}
        pergunta={header?.stPassou === false ? '“Seu filho...”' : undefined}
      />
      {hasExemplos && (
        <HistoricoMchatExemplosPassouFalhouTableItem exemplosPassou={exemplosPassou} exemplosFalhou={exemplosFalhou} />
      )}
      {frequencia && (
        <HistoricoMChatSimpleHorizontalTableItem
          pergunta={frequencia.textoPergunta}
          resposta={formatPergunta16Frequencia(frequencia.stPassou)}
        />
      )}
      {resultado && <HistoricoMChatResultadoParcialTableItem valor={resultado === PassouFalhouEnum.PASSOU} />}
    </HistoricoMChatPerguntaSection>
  )
}
